<template>
    <div id="app" :class="{'app-platform': isApp}">
        <reo-header :isApp="isApp" :showCommon="showCommon"></reo-header>
        <!--保持页面不至于形变过大-->
        <div class="pageContainer">
            <router-view/>
        </div>
        <reo-dialog
            v-if="logouted"
            :title="loginExpired"
            :labelOfConfirm="$t( 'dialog.yes' )"
            :labelOfCancel="$t( 'dialog.no' )"
            :switchButton="true"
            @confirm="refresh"
            @cancel="refresh"
        ></reo-dialog>
        <reo-need-help v-if="!isApp && showCommon &&!isDeviceSetting"></reo-need-help>
        <reo-footer v-if="!isApp && showCommon &&!isDeviceSetting"></reo-footer>
        <reo-dialog
            v-if="loginError"
            :labelOfConfirm="$t('login_error.refresh')"
            :labelOfCancel="$t('login_error.login')"
            :title="$t('login_error.title')"
            :description="$t('login_error.des')"
            class="login-error"
            @confirm="refresh"
            @cancel="goToLogin"
        ></reo-dialog>
        <PortalTarget name="body"></PortalTarget>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import reoHeader from '@/view/reolink/Header/index.vue';
import reoFooter from 'VIEW/Footer.vue';
import reoNeedHelp from '@/components/needHelp.vue';
import ReoDialog from '@/basic/Dialog.vue';
import user from '@/api/user';
import { config } from 'CONFIG';
import { getScrollBarWidth, throttle } from '@/common/js/utils';
import { NOOP } from './utils';
import { PortalTarget } from 'portal-vue';
import { ensureGdprCookies } from '@/common/js/gdprCookie';

export default Vue.extend({
    name: 'App',
    components: {

        reoFooter,
        reoHeader,
        reoNeedHelp,
        ReoDialog,
        PortalTarget

    },
    mounted () {

        $( 'body' ).removeClass( 'not-mounted' );
        this.resizeHandle();

        this.resizeFun = throttle( this.resizeHandle, 100 );
        window.addEventListener( 'resize', this.resizeFun );

        ensureGdprCookies().catch( console.error );

    },
    beforeDestroy () {

        window.removeEventListener( 'resize', this.resizeFun );

    },
    data () {

        return {

            loginExpired: this.$t( 'errors.logout_forced' ),
            isApp: config.platform === 'app',
            dialogStack: [] as any[],
            resizeFun: NOOP as (() => void ),
        };

    },
    methods: {

        refresh (): void {

            window.location.reload();
            this.$store.commit( 'LOGIN_ERROR', false );

        },
        goToLogin (): void {

            user.goToAccountCenter( true ).catch( console.error );
            this.$store.commit( 'LOGIN_ERROR', false );

        },
        resizeHandle (): void {

            let width = window.innerWidth;
            const oemBoundary = config.oem === 'reolink' ? 1200 : 1000;
            if ( width >= oemBoundary && this.screenWidth === 'mobile' ) {

                this.$store.commit( 'SCREENWIDTH_CHANGE', 'pc' );

            } else if ( width < oemBoundary && this.screenWidth === 'pc' ) {

                this.$store.commit( 'SCREENWIDTH_CHANGE', 'mobile' );

            }

            document.documentElement.style.setProperty( '--scrollbar-width', `${getScrollBarWidth()}px` );

        }

    },
    computed: {

        logouted (): boolean {

            return this.$store.state.logoutForced.status;

        },
        loginError (): boolean {

            return this.$store.state.loginError.status;

        },
        showCommon (): boolean {

            let path = this.$route.path;
            return !path.includes( '/user/invoice/' );

        },
        isDeviceSetting(): boolean {

            return this.$route.path.includes( '/user/device-settings' );

        },
        screenWidth (): string {

            return this.$store.getters.screenWidth;

        }

    }
});
</script>

<style>
    .logout-forced #cancle-button{

        display: none;

    }

    .dialogActivated{
        padding-right: var(--scrollbar-width);
        height: 100%;
        overflow: hidden;
    }

</style>

<style lang='less' scoped>
.login-error{
    & /deep/ .reo-dialog-inner{
        @media @pc{
            min-height:unset !important;
        }
    }

}

.app-platform{
    min-height: 100vh;
    min-height: 100dvh;
    background-color: @bg_01;
}

.pageContainer{
    min-height: calc( 100vh - 470px);
    background-color: @bg_01;
    display: flow-root;
    width: 100%;
}
</style>

<style>
</style>
